import { Injectable } from "@angular/core";

@Injectable()
export class UtilsService {
    public static recursiveDeepCopy(o) {
        let newO, i;

        if (typeof o !== "object") {
            return o;
        }
        if (!o) {
            return o;
        }

        if ("[object Array]" === Object.prototype.toString.apply(o)) {
            newO = [];
            for (i = 0; i < o.length; i += 1) {
                newO[i] = this.recursiveDeepCopy(o[i]);
            }
            return newO;
        }

        if ("[object Map]" === Object.prototype.toString.apply(o)) {
            newO = new Map();
            const keys = Array.from(o.keys());
            for (i = 0; i < keys.length; i += 1) {
                const key = keys[i];
                newO.set(key, this.recursiveDeepCopy(o.get(key)));
            }
            return newO;
        }

        newO = {};
        for (i in o) {
            if (Object.prototype.hasOwnProperty.call(o, i)) {
                newO[i] = this.recursiveDeepCopy(o[i]);
            }
        }
        return newO;
    }

    /**
     * Given an array and a predicate which returns a Promise<boolean>, returns Promise<true>
     * if an element in the array satisfies the predicate. Returns Promise<false> otherwise.
     */
    public static async asyncSome(arr, predicate) {
        for (const e of arr) {
            if (await predicate(e)) return true;
        }
        return false;
    }

    public static unique(value, index, array) {
        return array.indexOf(value) === index;
    }

    public static isNullOrWhitespace(input: string): boolean {
        return !input || !input.trim();
    }

    public static enforceMinMax(el) {
        if (el.value != "") {
            if (parseInt(el.value) < parseInt(el.min)) {
                el.value = el.min;
            }
            if (parseInt(el.value) > parseInt(el.max)) {
                el.value = el.max;
            }
        }
    }

    public static objectIsEmpty(obj: object): boolean {
        return Object.keys(obj).length === 0;
    }

    public static foldDiacritics(text: string, locale?: string): string {
        const input = (text ?? "").toString();
        let out = input.toLocaleLowerCase(locale);

        out = out
            .replaceAll(/\u00A0|\u202F|\u2007/g, " ")
            .replaceAll(/[\u2019\u2018\u2032]/g, "'")
            .replaceAll(/[\u2013\u2014\u2212]/g, "-");

        if (locale?.toLowerCase().startsWith("fr")) {
            out = out.replaceAll(/œ/g, "oe").replaceAll(/æ/g, "ae").replaceAll(/Œ/g, "oe").replaceAll(/Æ/g, "ae");
        } else {
            out = out.normalize("NFKD").replaceAll(/\p{M}/gu, "");
        }

        out = out.replaceAll(/\s+/g, " ").trim();
        return out;
    }
}
